import EmptyPlaceholder from "common/components/emptyPlaceholder/emptyPlaceholder";
import { Modal } from "common/components/modal/modal";
import { Skeleton } from "common/components/skeleton/skeleton";
import { Flex } from "common/components/flex/flex";
import { useMetricCandidates } from "features/dashboard/sections/weeklyActivity/metricCard/metricCandidatesModal/hooks/useMetricCandidates";
import { JobCandidatePanel } from "features/dashboard/sections/weeklyActivity/metricCard/metricCandidatesModal/jobCandidatePanel/jobCandidatePanel";
import { SectionError } from "features/dashboard/components/sectionError";

export const MetricCandidatesModal = ({
  open,
  metric,
  closeModal,
  fetchCandidates,
}) => {
  const { data, count, loading, error } = useMetricCandidates(fetchCandidates);

  const title = loading ? metric : `${metric} (${count})`;

  const renderContent = () => {
    if (loading) {
      return <Skeleton paragraph={{ rows: 11, width: "100%" }} />;
    }

    if (error) {
      return (
        <SectionError title="Failed to load data" message={error.message} />
      );
    }

    if (data.length === 0) {
      return (
        <Flex align="start" justify="center" style={{ flexGrow: 1 }}>
          <EmptyPlaceholder description="No candidates found." />
        </Flex>
      );
    }

    return (
      <Flex direction="column" gap={12} style={{ width: "100%" }}>
        {data.map(({ job, candidates }) => (
          <JobCandidatePanel key={job.id} job={job} candidates={candidates} />
        ))}
      </Flex>
    );
  };

  return (
    <Modal open={open} onCancel={closeModal} title={title} footer={null}>
      <Flex style={{ minHeight: "320px" }}>{renderContent()}</Flex>
    </Modal>
  );
};
